import { Circle } from '@mui/icons-material';
import { Alert, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Rating from '@mui/material/Rating';
import { styled } from '@mui/material/styles';
import { doc, setDoc } from 'firebase/firestore';
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getRatingLabelText, isStepNotComplete } from '../../common/utils';
import { PersonalityQuestionDetails, RatingLabels, UserPersonality, UserProfileStep } from '../../consts/types/user';
import { db } from '../../firebase';
import { UserSelectors, userActionsCreators } from '../../reducers/user';
import LinearProgressWithLabel from '../Common/LinearProgressWithLabel';
const { NotificationManager } = require('react-notifications');


const StyledRating = styled(Rating)({
    gap: 2,
    '& .MuiRating-iconFilled': {
        color: '#1976d2',
    },
    '& .MuiRating-iconHover': {
        color: '#3390ed',
    },
});

interface PersonalityProps {

}

type Props = PersonalityProps;


const Personality: FC<Props> = (props: Props) => {
    const user = useSelector(UserSelectors.currentUser);
    const [personality, setPersonality] = useState(user?.personality || {} as Record<string, UserPersonality>);
    const [hover, setHover] = useState<Record<string, number>>({} as any);

    const dispatch = useDispatch();

    useEffect(() => {
        setPersonality(user?.personality || {} as Record<string, UserPersonality>);
    }, [user?.personality]);

    const save = (questionText: string, rank: number | null) => {
        if (user?.email) {
            const question = PersonalityQuestionDetails.find(q => q.question === questionText)!;
            if (user) {
                dispatch(userActionsCreators.setUser({ user: { ...user, personality: { ...user.personality, [questionText]: question.revert && rank ? { type: question.type, rating: Object.keys(RatingLabels).length + 1 - rank } : { type: question.type, rating: rank } } } }));
            }
            setDoc(doc(db, "users", user.email), {
                personality: { [questionText]: question.revert && rank ? { type: question.type, rating: Object.keys(RatingLabels).length + 1 - rank } : { type: question.type, rating: rank } },
            }, { merge: true })
                .catch(() => {
                    NotificationManager.error('Something went wrong. Please try again.',);
                });
        }
    }
    return <Box display="flex" flexDirection="column" pb={{ xs: 1, md: 3 }} flex={1} gap={1}>
        {isStepNotComplete(UserProfileStep.PersonalityQuiz) && <Alert severity='warning' sx={{ display: { xs: "flex", md: "none" } }}>Step is not completed yet</Alert>}
        <Typography fontSize="0.875rem" color="text.secondary" mb={1}>When answering the questions, remember, there are no "right" or "wrong" answers, each answer is individual. </Typography>
        <LinearProgressWithLabel value={(personality ? Object.values(personality).filter(val => !!val.rating).length : 0) / PersonalityQuestionDetails.length * 100} />
        {PersonalityQuestionDetails.map(question => <Box mt={2}>
            <Typography mb={2} fontSize="0.95rem">{question.question}</Typography>
            <Box
                sx={{
                    width: 200,
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                <StyledRating size="large"
                    value={question.revert && personality[question.question] && personality[question.question].rating ? Object.keys(RatingLabels).length + 1 - (personality[question.question].rating || 0) : personality[question.question] ? personality[question.question].rating : null}
                    precision={1}
                    getLabelText={getRatingLabelText}
                    onChange={(event, newValue) => {
                        save(question.question, newValue);
                        setPersonality({ ...personality, [question.question]: question.revert && newValue ? { type: question.type, rating: Object.keys(RatingLabels).length + 1 - newValue } : { type: question.type, rating: newValue } });
                    }}
                    onChangeActive={(event, newHover) => {
                        setHover({ ...hover, [question.question]: newHover });
                    }}
                    icon={<Circle fontSize="inherit" />}
                    emptyIcon={<Circle style={{ opacity: 0.55 }} fontSize="inherit" />}
                />
                {personality[question.type] !== null && (
                    <Box sx={{ ml: 2, whiteSpace: "nowrap" }}>{RatingLabels[hover[question.question] !== -1 ? hover[question.question] : personality[question.question] ? personality[question.question].rating || 0 : 0]}</Box>
                )}
            </Box>
        </Box>)}



    </Box>;
}


export default Personality;

